import React from 'react';
import colors from '../../colors';
import { Line, Name, Bar, Progress, Value } from './styles';

export default (props) => {
	const value = props.getValue(props);
	const renderValue = props.renderValue ? props.renderValue(props) : value;
	const relative = props.max ? value / props.max * 100 : 0;
	return <Line>
		<Name>{props.name}</Name>
		<Bar>
			<Progress style={{ width: relative +'%', backgroundColor: colors[props.id] || colors.default }} />
		</Bar>
		<Value>{renderValue}</Value>
	</Line>
}
